import store from '@/store'

export default function useTreatmentDiary() {
  const getTreatmentDiaryInfo = async id => await store.dispatch('patient/getTreatmentDiaryInfo', id)
  const getTreatmentDiary = async id => await store.dispatch('patient/getTreatmentDiary', id)

  return {
    getTreatmentDiaryInfo,
    getTreatmentDiary,
  }
}